<template>
    <div>
        <v-container style="max-width: 1300px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 1rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Horarios
                    <!--  
                        <v-tooltip bottom color="success">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="green" v-bind="attrs" v-on="on" dark @click="exportExcel"
                                    style="margin: 1rem 0;height: 1.9rem;">
                                    <v-icon color="white"
                                        style="font-size: 1.5rem;color: white !important;">mdi-download-box</v-icon>
                                </v-btn>
                            </template>
<span>Descargar</span>
</v-tooltip>
-->
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1"
                style="margin-bottom: 2rem !important;padding: 2rem .6rem 0 .6rem;">
                <v-row>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchHorario" label="Horario"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <!--  <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchNombreCompleto"
                            label="Nombre Completo" append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchCargo" label="Cargo"
                            append-icon="mdi-magnify" outlined dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchCondIngreso" label="Condición Ingreso"
                            append-icon="mdi-magnify" outlined dense>
                        </v-text-field>
                    </v-col> -->
                    <v-col cols="12" lg="3" md="2">
                        <!-- <v-text-field max-width="200" class="mx-3" v-model="searchCargo" label="Área"
                            append-icon="mdi-magnify" outlined dense>
                        </v-text-field> -->
                        <el-button type="primary" @click="dialogEdit = true">Nuevo</el-button>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <div>
                    <v-data-table :headers="filteredHeaders" :items="filteredData" :loading="isLoading" dense
                        loading-text="Cargando... Por favor espere" style="margin: 0 auto;">
                        <template v-slot:[`item.actions`]="{ item }">
                            <!-- <v-tooltip top color="green" v-if="!item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark color="green" v-bind="attrs" v-on="on"
                                        @click="darAltaUsuario(item)">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-transfer-up
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Dar de alta</span>
                            </v-tooltip>
                            <v-tooltip top color="red" v-if="item.estado">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark color="red" v-bind="attrs" v-on="on"
                                        @click="darBajaUsuario(item)">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-transfer-down
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Dar de baja</span>
                            </v-tooltip> -->
                            <v-tooltip top color="yellow">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="openEdit(item)" color="yellow"
                                        v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-account-edit
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.estado`]="{ item }">
                            <span :class="item.estado ? 'activo' : 'desactivado'">
                                {{ item.estado ? 'Activo' : 'Desactivado' }}
                            </span>
                        </template>

                    </v-data-table>
                </div>
                <el-dialog :title="titleForm" :visible.sync="dialogEdit">
                    <el-form :model="horariosForm" label-position="top" :rules="rules" ref="horariosForm">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <el-form-item label="Hora Inicio" :label-width="formLabelWidth" prop="hora_inicio">
                                    <!-- <el-input v-model="horariosForm.hora_inicio" autocomplete="off"></el-input> -->
                                    <el-time-select placeholder="Hora Inicio" v-model="horariosForm.hora_inicio"
                                        :picker-options="{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00'
                                        }">
                                    </el-time-select>
                                </el-form-item>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <el-form-item label="Hora Fin" :label-width="formLabelWidth" prop="hora_fin">
                                    <!-- <el-input v-model="horariosForm.hora_fin" autocomplete="off"></el-input> -->
                                    <el-time-select placeholder="Hora final" v-model="horariosForm.hora_fin" :picker-options="{
                                        start: '00:00',
                                        step: '00:15',
                                        end: '24:00',
                                        minTime: horariosForm.hora_inicio
                                    }" @change="loadHorarioInput()">
                                    </el-time-select>
                                </el-form-item>
                            </v-col>
                        </v-row>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="closeEdit">Cancelar</el-button>
                        <el-button type="primary" @click="submitForm('horariosForm')"
                            v-if="!statusEdit">Confirmar</el-button>
                        <el-button type="primary" @click="editForm('horariosForm')"
                            v-if="statusEdit">Guardar</el-button>
                    </span>
                </el-dialog>
            </v-card>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
.el-form-item__label {
    line-height: 0px !important;
}

.activo {
    color: rgb(255, 255, 255);
    background: #74d467;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

.desactivado {
    color: rgb(255, 255, 255);
    background: #df4141;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

::v-deep .theme--dark.v-system-bar {
    color: hsl(0, 0%, 100%) !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 25px !important;
    height: 25px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    data() {
        return {
            rules: {
                hora_inicio: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                hora_fin: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ]
            },
            titleForm: 'Nuevo Horario',
            formLabelWidth: '70px',
            valid: true,
            idHorario: null,
            titleButton: 'Guardar',
            horariosForm: {
                hora_inicio: null,
                hora_fin: null,
                horario:null
            },
            searchSala: [],
            statusEdit: false,
            modal: false,
            searchHorario: null,
            searchNombreCompleto: null,
            searchCargo: null,
            searchCondIngreso: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            dataPaciente: [],
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Horario", value: "horario" },
                { text: "Fecha de creación", value: "fecha_creacion" },
                { text: "Fecha de edición", value: "fecha_edicion" },
                { text: "Acciones", value: "actions", align: "right" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            dataArray: [],
            arrayAreas: [],
            arrayRoles: [],
            dataUsuariosHisar: []
        };
    },
    watch: {
        dialogEdit(newVal, oldVal) {
            if (newVal) {
                console.log("El diálogo se abrió.");
            } else {
                this.closeEdit();
                console.log("El diálogo se cerró.");
            }
        },
    },
    methods: {
        loadHorarioInput(){
            this.horariosForm.horario=`${this.horariosForm.hora_inicio} - ${this.horariosForm.hora_fin}`
        },
        editForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.edit();
                } else {
                    return false;
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.save();
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        darAltaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de alta al personal?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/rrhh_planilla_personal/" + item.id + "/", {
                                    estado: true
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        darBajaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de baja al personal?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/rrhh_planilla_personal/" + item.id + "/", {
                                    estado: false
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        clearForm() {
            this.horariosForm = {
                hora_inicio: null,
                hora_fin: null,
                horario:null
            }
        },
        openEdit(item) {
            this.titleForm = 'Editar Horario',
                this.statusEdit = true;
            this.idHorario = item.id;
            this.dialogEdit = true;
            this.horariosForm.hora_inicio = item.hora_inicio;
            this.horariosForm.hora_fin = item.hora_fin;
            this.horariosForm.horario = item.horario;
        },
        closeEdit() {
            this.resetForm('horariosForm');
            this.statusEdit = false;
            this.dialogEdit = false;
            this.titleForm = 'Nuevo Personal',
                this.clearForm();
        },
        save() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/rrhh_planilla_horarios/", this.horariosForm, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El horario se registró con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.clearForm();
                            this.statusEdit = false;
                        })
                        .catch((res) => {
                            this.dialogEdit = false;
                            console.log("Error:", res);
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        edit() {
            this.dialogLoader = true;
            this.statusEdit = true;
            this.dialogEdit = false;
            axios
                .put(RUTA_API + "/rrhh_planilla_horarios/" + this.idHorario + "/", this.horariosForm)
                .then((res) => {
                    Swal.fire({
                        title: "¡Exito!",
                        text: "El horario se editó con exito.",
                        icon: "success",
                        draggable: true
                    });
                    this.dataInit();
                    this.dialogLoader = false;
                    this.statusEdit = false;
                })
                .catch((res) => {
                    console.log("Error:", res);
                });

        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/rrhh_planilla_horarios/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;
                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        filteredData() {
            if (!this.searchHorario) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchHorario) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.horario;
                    return nombreCompleto.toLowerCase().includes(this.searchHorario.toLowerCase());
                });
            }
            return filtered;
        },
    },
    created() {
        this.dataInit();
    },
    components: {},
};
</script>